import { Dropdown, MenuProps, Space } from "antd";
import { FunctionComponent, useState } from "react";
import "./index.less";

const menuList = [
  {
    name: "首页",
    EnglishName: "Home",
  },
  {
    name: "平台介绍",
    EnglishName: "Introduction",
  },
  {
    name: "调解机构",
    EnglishName: "Organization",
  },
  {
    name: "示范判例",
    EnglishName: "Model Case",
  },
  {
    name: "帮助中心",
    EnglishName: "Help",
  },
  {
    name: "共建单位",
    EnglishName: "Units",
  },
];

interface HomeProps { }

const Home: FunctionComponent<HomeProps> = () => {
  const [activeMenu, setActiveMenu] = useState(menuList[0]);
  const items: MenuProps["items"] = [
    {
      key: "1",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://ghkstj.com/etna/login"
        >
          当事人调解码登录
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://ghkstj.yuntrial.com/lassen/party/app/login"
        >
          当事人账户登录
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://ghkstj.com/app/login"
        >
          调解员登录
        </a>
      ),
    },
  ];
  const handleRegister = () => {
    window.open("https://ghkstj.yuntrial.com/lassen/party/app/register", "_blank");
  };

  return (
    <div className="home-page">
      <div className="page-header">
        <div className="header-left">
          <img
            className="header-left-logo"
            src="https://cdnimg-pro.gdapi.net/images/1749620718982_2525.png"
            alt="logo"
          />
          <div className="page-title">枫桥e站·快手站</div>
        </div>
        <div className="page-menu">
          <ul className="menu-list">
            {menuList.map((item) => (
              <li
                className={`menu-item ${activeMenu.EnglishName === item.EnglishName ? "active" : ""
                  }`}
                key={item.EnglishName}
                onClick={() => setActiveMenu(item)}
              >
                <div className="item-name">{item.name}</div>
                <div className="item-english-name">{item.EnglishName}</div>
              </li>
            ))}
          </ul>
        </div>
        <div className="header-right">
          <Dropdown menu={{ items }}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                <div className="login-btn">
                  <div className="login-btn-name">登录</div>
                  <div className="login-btn-english-name">Login In</div>
                </div>
              </Space>
            </a>
          </Dropdown>
          <div className="register-btn" onClick={handleRegister}>
            <div className="register-btn-name">注册</div>
            <div className="register-btn-english-name">Register</div>
          </div>
        </div>
      </div>
      <div className="page-body">
        <div className="carousel-content">
          <div className="carousel-content-inner">
            {/* <img
              className="inner-bg"
              src="https://cdnimg-pro.gdapi.net/images/1749626469759_7851.png"
              alt=""
            /> */}
            <div className="carousel-title">
              <div className="carousel-title-main">构建"互联网+调解"新生态</div>
              <div className="carousel-title-sub">
                让非诉机制成为化解矛盾的第一道防线
              </div>
            </div>
            <div className="carousel-btn-group">
              <div className="carousel-btn" onClick={() => { window.open('https://ghkstj.yuntrial.com/lassen/party/app/admin/my-mediation-list', '_self'); }}>
                <div className="carousel-btn-title">我要调解</div>
                <div className="carousel-btn-sub">I need mediation</div>
              </div>
            </div>
          </div>
        </div>
        <div className="demonstration-case">
          <div className="block-title">示范案例</div>
          <div className="case-list">
            <div className="case-item">
              <div className="case-item-bg">
                <img
                  src="https://cdnimg-pro.gdapi.net/images/1749620718847_5391.png"
                  alt="案例背景"
                />
              </div>
              <div className="case-item-content">
                <div className="case-item-title">法脉准绳</div>
                <div className="case-item-desc">以案明法脉，以理释准绳</div>
                <div className="case-item-btn" onClick={() => { window.open('https://mp.weixin.qq.com/mp/appmsgalbum?__biz=MzU2NzcwMTIwMA==&action=getalbum&album_id=1361527484256485377#wechat_redirect'); }}>查看详情</div>
              </div>
            </div>
            <div className="case-item">
              <div className="case-item-bg">
                <img
                  src="https://cdnimg-pro.gdapi.net/images/1749620719935_8402.png"
                  alt="案例背景"
                />
              </div>
              <div className="case-item-content">
                <div className="case-item-title">典案搜搜</div>
                <div className="case-item-desc">广州互联网法院典型案例</div>
                <div className="case-item-btn" onClick={() => { window.open('https://project.ycwb.com.cn/2021/gzhlwfy'); }}>查看详情</div>
              </div>
            </div>
          </div>
        </div>
        <div className="mediation-process">
          <div className="block-title">调解流程</div>
          <div className="mediation-process-bg">
            <img
              className="mediation-process-img"
              src="https://cdnimg-pro.gdapi.net/images/1749620719093_6070.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="page-footer">
        <div className="page-lassen-foot-link">
          <a
            href="http://www.court.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            最高人民法院
          </a>
          <span>|</span>
          <a
            href="http://www.chinacourt.org/index.shtml"
            target="_blank"
            rel="noopener noreferrer"
          >
            中国法院网
          </a>
          <span>|</span>
          <a
            href="http://www.court.gov.cn/zgcpwsw/"
            target="_blank"
            rel="noopener noreferrer"
          >
            中国裁判文书网
          </a>
          <span>|</span>
          <a
            href="http://tingshen.court.gov.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            中国庭审公开网
          </a>
          <span>|</span>
          <a
            href="http://rmfyb.chinacourt.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            人民法院报
          </a>
          <span>|</span>
          <a
            href="http://www.legaldaily.com.cn/"
            target="_blank"
            rel="noopener noreferrer"
          >
            法制日报
          </a>
          <span>|</span>
          <a
            href="http://www.chinalawinfo.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            北大法律信息网
          </a>
          <span>|</span>
          <a
            href="http://njc.chinacourt.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            国家法官学院
          </a>
        </div>
        <div className="footer-info">
          <span>调解咨询电话：020-36690765、020-36690768</span>
          <span>工作时间：(周一-周五)9:00-18:00</span>
        </div>
        <div className="footer-bottom">
          <span><a href="https://beian.miit.gov.cn/ " target="_blank" style={{ color: '#fff', textDecoration: 'none' }}>备案号: 粤ICP备2025424695号</a></span>
          <span>版权所有：华智云调（深圳）技术服务有限公司</span>
        </div>
      </div>
    </div>
  );
};

export default Home;
